<script setup lang="ts">
import type { Property } from "~/classes/entity"

const props = defineProps({
  fileId: null,
  properties: null
})
const { getFileReference } = useAgent()

const file = computed(() => getFileReference(props.fileId))

// TODO: use the property types to display the given properties
const _propertyTypes = computed(() => {
  const properties = props.properties.split(",").map(p => p as Property)
  return properties
})
</script>

<template>
  <file-detail
    v-if="isDefined(file)"
    :file
    selectable
  />
  <template v-else>
    [broken file]
  </template>
</template>
